import {
    Flex,
    Input,
    Text,
    Box,
    FormLabel,
    RadioGroup,
    Radio,
    Stack,
    Button,
    useToast
} from '@chakra-ui/react'
import { deleteDoc, doc, setDoc } from 'firebase/firestore'
import {deleteObject, getDownloadURL, ref, uploadBytesResumable} from 'firebase/storage'

import React, { useState } from 'react'
import useApp from '../context/AppContext'
import db, {storage} from '../firebase'

function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

function AllPlayers() {

    const {players, setPlayers, reservedPlayers, setReservedPlayers, soldPlayers} = useApp()
    const [search, setSearch] = useState("")
    const [image, setImage] = useState(null)
    const toast = useToast()

    const [edit, setEdit] = useState(null)

    const handleChange = async (e) => {

        setEdit(s => ({
            ...s, 
            [e.target.name]: e.target.value
        }))
    }

    const editImage = async () => {
        const storageRef = ref(storage, `${uuidv4()}`)
        const uplaodTask = await uploadBytesResumable(storageRef, image)
        
        const url = await getDownloadURL(uplaodTask.ref)
        return url
    }

    const postData = async () => {

        toast({
            position: 'bottom-right',
            title: `Changing Player Data...`,
            // status: `success`,
            duration: 1000,
            isClosable: true,
        })

        const key = edit.pid;
        delete edit.pid
        // console.log(edit)

        if(image)
            edit['image']= await editImage()
        console.log(edit)
        // return
        await setDoc(doc(db, 'players', key), {
            ...edit
        })

        edit.pid = key
        players.players[key] = {...edit}
        setPlayers({...players})

        toast({
            position: 'bottom-right',
            title: `Player Data edited`,
            status: `success`,
            duration: 1000,
            isClosable: true,
        })

        setEdit(null)
        setImage(null)
    }

    const deletePlayer = async (key) => {

        toast({
            position: 'bottom-right',
            title: `Deleting Player: ${players.players[key].mid}`,
            // status: `success`,
            duration: 1000,
            isClosable: true,
        })

        try {
            const imageRef = ref(storage, players?.players[key].image)
            console.log(imageRef)
            await deleteObject(imageRef)
        } catch (e) {}

        try {
            console.log("deleting reserved player", key)
            const reservedPlayer = reservedPlayers.filter(r => r.pid === key)
            console.log(reservedPlayer)
            if(reservedPlayer.length >= 1)
            await deleteDoc(doc(db, 'reservedplayers', reservedPlayer[0].rid))
            console.log("deleting sold player", key)
            toast({
                position: 'bottom-right',
                title: `Deleted Reserved Player: ${players.players[key].mid}`,
                // status: `success`,
                duration: 1000,
                isClosable: true,
            })
            const soldPlayer = soldPlayers.filter(s => s.pid === key)
            console.log(soldPlayer)
            if(soldPlayer.length >= 1)
            await deleteDoc(doc(db, 'soldplayers', soldPlayer[0].aid))
            console.log("deleting player", key)
            toast({
                position: 'bottom-right',
                title: `Deleted Auction: ${players.players[key].mid}`,
                // status: `success`,
                duration: 1000,
                isClosable: true,
            })
            await deleteDoc(doc(db, 'players', key))
            delete players?.players[key]
            players.list = players?.list.filter(k => k !== key)
            setPlayers({...players})
            if(reservedPlayer.length >= 1)
            setReservedPlayers(r => ([...r.filter(r => r.pid !== key)]));
            
            toast({
                position: 'bottom-right',
                title: `Player Deleted`,
                status: `success`,
                duration: 1000,
                isClosable: true,
            })

            window.location.reload()

        } catch(e) {
            console.log(e)
            return
        }
    }

    return (
        <Flex
            direction={'column'}
            gap={4}
            w={'full'}
            px={5}
            pt={5}
        >
            {edit?
                <Flex
                    w={'100vw'}
                    h={'100vh'}
                    bg={'rgba(0,0,0,0.4)'}
                    position="fixed"
                    top={0}
                    right={0}
                    left={0}
                    bottom={0}
                    backdropFilter={'blur(10px)'}
                    zIndex="1"
                    direction="column"
                    gap={5}
                    alignItems={'center'}
                >

                    <Button
                        position={'absolute'}
                        top={5}
                        right={9}
                        onClick={() => {setEdit(null);setImage(null)}}
                    >X</Button>
                    <Flex
                        justifyContent={'center'}
                        direction={'row'}
                        wrap={'wrap'}
                        mx={'auto'}
                        p={10}
                        gap={10}

                    >
                    <Box w={'30%'}>
                        <FormLabel htmlFor='name'>Full Name</FormLabel>
                        <Input  
                            id='name' 
                            type='text' 
                            name="name" 
                            onChange={(e) =>handleChange(e)}
                            value={edit?.name || ""}
                        />
                    </Box>
                    <Box w={'30%'}>
                        <FormLabel htmlFor='image'>Image</FormLabel>
                        <Input 
                            id='image' 
                            type='file' 
                            name="image"
                            border={'none'}
                            accept="image/png, image/jpeg"
                            onChange={(e) => setImage(e.target.files[0])}
                            />
                    </Box>

                    <Box w={'30%'}>
                        <FormLabel htmlFor='phone'>Phone</FormLabel>
                        <Input 
                            id='phone' 
                            type='phone' 
                            name="phone"
                            onChange={(e) =>handleChange(e)}
                            value={edit?.phone || ""}
                        />
                    </Box>

                    <Box w={'30%'}>
                        <FormLabel htmlFor='category'>Category</FormLabel>
                        <Input 
                            id='category' 
                            type='text' 
                            name="category"
                            onChange={(e) =>handleChange(e)}
                            value={edit?.category || ""}
                        />
                    </Box>
                    <Box w={'30%'}>
                        <FormLabel htmlFor='mid'>Membership No.</FormLabel>
                        <Input 
                            id='mid' 
                            type='text' 
                            name="mid"
                            onChange={(e) =>handleChange(e)}
                            value={edit?.mid || ""}
                        />
                    </Box>
                    <Box w={'30%'}>
                        <FormLabel htmlFor='type'>Lefty/Righty</FormLabel>
                        <RadioGroup name="type" id="type" onChange={(e) => setEdit(d => ({...d, type:e}))} value={edit?.type}>
                        <Stack direction='row'>
                            <Radio value='lefty'>Lefty</Radio>
                            <Radio value='righty'>Righty</Radio>
                        </Stack>
                        </RadioGroup>
                    </Box>

                    </Flex>

                    <Flex
                alignItems={'center'}
                gap={5}
            >
                <Text>Last Year Stats</Text>
                <Box w={'30%'}>
                    <FormLabel htmlFor='score'></FormLabel>
                    <Input 
                        id='score' 
                        type='text' 
                        name="score"
                        placeHolder={'Score'}
                        onChange={(e) =>handleChange(e)}
                        value={edit?.score || ""}
                    />
                </Box>
                <Box w={'30%'}>
                    <FormLabel htmlFor='wickets'></FormLabel>
                    <Input 
                        id='wickets' 
                        type='text' 
                        name="wickets"
                        placeHolder={'Wickets'}
                        onChange={(e) =>handleChange(e)}
                        value={edit?.wickets || ""}
                    />
                </Box>
            </Flex>

                    <Flex
                        gap={5}
                        wrap={'wrap'}
                    >
                        {Object.keys(edit?.atts).map(key => {

                            return (
                                <Text
                                    px={4}
                                    py={2}
                                    border={'1px'}
                                    borderColor={'gray.700'}
                                    borderRadius={20}
                                    key={key}
                                    cursor={'pointer'}
                                    transition="all 0.25s"
                                    _hover={{
                                        borderColor:'gray.500'
                                    }}

                                    bg={edit.atts[key]?'cyan.600':""}

                                    onClick={() => setEdit(e => ({...e, atts: {...e.atts,[key]:!e.atts[key]}}))}
                                
                                >{key}</Text>
                            )

                        })}
                    </Flex>



                    <Button mx={"auto"} w={'90%'} onClick={()=>postData()}>Submit</Button>

                </Flex>:<></>
            }

            <Input 
                type={'text'}
                maxW={'70%'}
                m={'auto'}
                placeholder="Search Player"
                value={search}
                onChange={e => setSearch(e.target.value)}
            />

            <Text textAlign={'center'}>Total Players: {Object.keys(players?.players).length}</Text>

            {players?.list.map((key, index) => {
                let player;
                if(players?.players[key]?.name)
                    if(search?.length > 0)
                        player = players?.players[key]?.name.toLowerCase().includes(search.toLowerCase())?players.players[key]: null
                    else
                        player = players?.players[key]


                if(player)
                return (
                    <Flex
                    height={50}
                    alignItems={'center'}
                    px={5}
                    key={key}
                    border='1px' 
                    borderColor='gray.700'
                    borderRadius={10}
                    justifyContent={'space-between'}
                    transition={'all 0.25s ease'}
                    _hover= {{
                        color: 'cyan.500',
                        borderColor: 'cyan.500',
                        transform: 'translateY(-3px)'
                    }}
                    role={'group'}
                    >    
                        {player.mid}. {player.name}
                    <Flex
                        gap={2}
                    >
                    <Text 
                        bg={'cyan.700'}
                        px={2}
                        py={1}
                        borderRadius={10}
                        color={'white'}
                        display={'none'}
                        _groupHover={{
                            display:"flex"
                        }}
                        cursor={"pointer"}
                        onClick={() => setEdit(player)}
                    >Edit</Text>
                    <Text 
                        bg={'red.700'}
                        px={2}
                        py={1}
                        borderRadius={10}
                        color={'white'}
                        display={'none'}
                        _groupHover={{
                            display:"flex"
                        }}
                        cursor={"pointer"}
                        onClick={() => deletePlayer(key)}
                    >Delete</Text>
                    </Flex>

                    </Flex>
                )
            })}
        </Flex>
    )
}

export default AllPlayers